// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, HasPagingParameters, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface GetOrderAwaitingApprovalApiParameter extends ApiParameter, HasPagingParameters {
    customer?: string;
    count?: string;
}
export interface OrderAwaitingApprovalModel extends BaseModel {
    customer: string;
    orderCount: number;
    id: string;
}

export interface OrderAwaitingApprovalCollectionModel extends BaseModel {
    customerOrderApprovals: OrderAwaitingApprovalModel[] | null;
    pagination: PaginationModel | null;
}

const orderAwaitingApprovalsUrl = "/api/guest/customOrderApproval/customOrderAwaitingApproval";

export async function getOrderAwaitingApprovals(
    parameter: GetOrderAwaitingApprovalApiParameter,
): Promise<ServiceResult<OrderAwaitingApprovalCollectionModel>> {
    try {
        let orderAwaitingApprovals = await get<OrderAwaitingApprovalCollectionModel>(
            orderAwaitingApprovalsUrl,
            parameter,
        );
        const customerOrderApprovals = orderAwaitingApprovals.customerOrderApprovals?.map(customerOrderApproval => {
            return {
                ...customerOrderApproval,
                id: `${customerOrderApproval.customer}-${customerOrderApproval.orderCount}`,
            };
        });
        orderAwaitingApprovals = { ...orderAwaitingApprovals, customerOrderApprovals: customerOrderApprovals || [] };
        return {
            successful: true,
            result: orderAwaitingApprovals,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
